import { useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import utc from 'dayjs/plugin/utc';
import { AppThemeProvider } from '@cbridge-modules/toolpad-core';
import { createTheme } from '@cbridge-utils/mui-theme';
import { DialogsProvider } from '@cbridge-modules/dialog';
import { Notifications } from '@cbridge-modules/notification';
import { AppLayout } from './layouts/AppLayout';
import { BrandingSync } from './branding/BrandingSync';
import { useBranding } from './branding/useBranding';
import 'simplebar-react/dist/simplebar.min.css';
import 'dockview-react/dist/styles/dockview.css';

export default function App() {
  dayjs.extend(duration);
  dayjs.extend(utc);

  const { brand } = useBranding();
  const theme = useMemo(() => createTheme(true, brand), [brand]);

  return (
    <AppThemeProvider theme={theme}>
      <BrandingSync />
      <DialogsProvider>
        <AppLayout>
          <Outlet />
        </AppLayout>
        <Notifications />
      </DialogsProvider>
    </AppThemeProvider>
  );
}
